import type { KeyboardEventHandler, PropsWithChildren } from "react";

import { cn } from "../../../utils";

interface ILabelProps {
  htmlFor?: string;
  className?: string;
  disabled?: boolean;
  tabIndex?: number;
  required?: boolean;
  onClick?: () => void;
  onKeyDown?: KeyboardEventHandler<HTMLElement>;
}

export const Label = ({
  children,
  htmlFor,
  className,
  disabled,
  tabIndex,
  required,
  onClick,
  onKeyDown,
}: PropsWithChildren<ILabelProps>) => {
  return (
    <label
      tabIndex={tabIndex}
      className={cn("inline-block leading-6 m-0 text-label", className)}
      aria-disabled={disabled}
      htmlFor={htmlFor}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      {children}
      {required && <span className="ml-0.5 text-red">*</span>}
    </label>
  );
};
